import { render } from "./Rajshahi.vue?vue&type=template&id=12dbcc02"
import script from "./Rajshahi.vue?vue&type=script&lang=js"
export * from "./Rajshahi.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/teachers.gov.bd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__